export enum ToggleIconSide {
  Left = `left`,
  Right = `right`,
}

export interface ToggleOption {
  label: string;
  value: string;
  disabled?: boolean;
  error?: boolean;
  icon?: string;
  iconColor?: string;
  iconSide?: ToggleIconSide;
  tooltipLabel?: string;
}

export type SelectEvent = CustomEvent<{
  selected: string;
}>;
